import { Link } from "react-router-dom";
import SectionWrapper from "../hoc/SectionWrapper";

const Pricing = () => {
  const plans = [
    {
      title: "Osnovni paket",
      price: "0 €",
      description: "Najbolji izbor za osobnu upotrebu i manje projekte.",
      features: [
        "Prilagodba pozivnica prema vašim željama",
        "Bez naknada za postavljanje i skrivenih troškova",
        "Ograničeno na 20 uzvanika",
        "Pregled svih uzvanika",
      ],
    },
    {
      title: "Prošireni paket",
      price: "29 €",
      description:
        "Idealan za veće proslave s više sudionika i proširenom podrškom.",
      features: [
        "Prilagodba pozivnica prema vašim željama",
        "Bez naknada za postavljanje i skrivenih troškova",
        "Ograničeno na 80 uzvanika",
        "Pregled svih uzvanika",
        "Slanje mailova za update događanja uključeno",
        "Premium podrška",
      ],
    },
    {
      title: "Premium paket",
      price: "69 €",
      description: "Najbolji za veće događaje s velikim brojem gostiju.",
      features: [
        "Prilagodba pozivnica prema vašim željama",
        "Bez naknada za postavljanje i skrivenih troškova",
        "Neograničen broj uzvanika",
        "Pregled svih uzvanika",
        "Slanje mailova za update događanja uključeno",
        "Premium podrška",
      ],
    },
  ];

  return (
    <div className="max-w-full sm:max-w-xl md:max-w-2xl lg:max-w-6xl xl:max-w-[85rem] mx-auto">
      <section className="bg-white  ">
        <div className="max-w-screen-xl px-4 py-8 mx-auto lg:py-24 lg:px-6">
          <div className="max-w-screen-md mx-auto mb-8 text-center lg:mb-12">
            <h2 className="mb-4 text-3xl font-extrabold tracking-tight text-gray-900  ">
              Prilagođeno za Vaše posebne trenutke
            </h2>
            <p className="mb-5 font-light text-gray-500 sm:text-xl  ">
              Na pozivnica.hr kreiramo unikatne pozivnice i personalizirane
              proizvode koji će svaki vaš događaj učiniti nezaboravnim. S
              fokusom na kreativnost, kvalitetu i detalje, naš cilj je omogućiti
              vam da slavite važne trenutke u životu na najposebniji način.
            </p>
          </div>
          <div className="space-y-8 lg:grid lg:grid-cols-3 lg:space-y-0">
            {plans.map((plan) => (
              <div
                key={plan.title}
                className="flex flex-col max-w-lg p-6 mx-auto text-center text-gray-900 bg-white border border-gray-100 rounded-xl shadow   xl:p-8     h-full transition hover:z-[1] hover:shadow-2xl hover:shadow-gray-600/10 hover:border-gray-300"
              >
                <h3 className="mb-4 text-2xl font-semibold">{plan.title}</h3>
                <p className="font-light text-gray-500 sm:text-lg  ">
                  {plan.description}
                </p>
                <div className="flex items-baseline justify-center my-8">
                  <span className="mr-2 text-5xl font-extrabold">
                    {plan.price}
                  </span>
                </div>
                <ul role="list" className="mb-8 space-y-4 text-left">
                  {plan.features.map((feature, index) => (
                    <li key={index} className="flex items-center space-x-3">
                      <svg
                        className="flex-shrink-0 w-5 h-5 text-green-500  "
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                <div className="mt-auto">
                  <Link to="/nova-pozivnica">
                    <button
                      type="button"
                      className="before:ease relative h-12 w-40 overflow-hidden shadow-2xl shadow-amber-400 border border-amber-300 bg-amber-300 font-semibold text-black rounded-md p-3 transition-all before:absolute before:right-0 before:top-0 before:h-12 before:w-6 before:translate-x-12 before:rotate-6 before:bg-white before:opacity-15 before:duration-700 hover:before:-translate-x-40"
                    >
                      Kreiraj pozivnicu
                    </button>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default SectionWrapper(Pricing, "");
